// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
// { getSeaLogs, getSeaLog, addSeaLog, updateSeaLog, deleteSeaLog }
import {
    getSeaLogs as listSeaLogAPI,
    getSeaLog as getSeaLogAPI,
    addSeaLog as addSeaLogAPI,
    updateSeaLog as updateSeaLogAPI,
    deleteSeaLog as deleteSeaLogAPI,
} from '../../helpers/';

import { seaLogApiResponseError, seaLogApiResponseSuccess } from './actions';
import { SeaLogActionTypes } from './constants';

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getSeaLog({ payload: { id } }) {
    try {
        const response = yield call(getSeaLogAPI, id );
        const seaLogItem = response.data.data;
        yield put(seaLogApiResponseSuccess(SeaLogActionTypes.GET_SEA_LOG, seaLogItem));
    } catch (error) {
        yield put(seaLogApiResponseError(SeaLogActionTypes.GET_SEA_LOG, error));
    }
}

function* addSeaLog({payload:seaLog}){
    try{
        const response = yield call(addSeaLogAPI,{...seaLog})
        const seaLogItem = response.data
        yield put(seaLogApiResponseSuccess(SeaLogActionTypes.ADD_SEA_LOG,seaLogItem))
    } catch(error){
        yield put(seaLogApiResponseError(SeaLogActionTypes.ADD_SEA_LOG,error))
    }
}

function* updateSeaLog({payload:seaLog}){
    try{
        const response = yield call(updateSeaLogAPI,{...seaLog})
        const seaLogItem = response.data.data
        yield put(seaLogApiResponseSuccess(SeaLogActionTypes.UPDATE_SEA_LOG,seaLogItem))
    }catch(error){
        yield put(seaLogApiResponseError(SeaLogActionTypes.UPDATE_SEA_LOG,error))
    }
}
function* deleteSeaLog({payload:{id}}){
    try{
        const response = yield call(deleteSeaLogAPI,id)
        const seaLogItem = response.data.id
        yield put(seaLogApiResponseSuccess(SeaLogActionTypes.DELETE_SEA_LOG,seaLogItem))
    }catch(error){
        yield put(seaLogApiResponseError(SeaLogActionTypes.DELETE_SEA_LOG,error))
    }
}

/**
 * List contactos
 */
function* listSeaLogs({payload:params}) {
    try {
        const response = yield call(listSeaLogAPI, { ...params });
        const listaSeaLogs = response.data.data;
        yield put(seaLogApiResponseSuccess(SeaLogActionTypes.LIST_SEA_LOGS, listaSeaLogs));
    } catch (error) {
        yield put(seaLogApiResponseError(SeaLogActionTypes.LIST_SEA_LOGS, error));
    }
}


export function* watchGetSeaLog(): any {
    yield takeEvery(SeaLogActionTypes.GET_SEA_LOG, getSeaLog);
}

export function* watchListSeaLogs(): any {
    yield takeEvery(SeaLogActionTypes.LIST_SEA_LOGS, listSeaLogs);
}

export function* watchAddSeaLog():any{
    yield takeEvery(SeaLogActionTypes.ADD_SEA_LOG,addSeaLog)
}
export function* watchUpdateSeaLog():any{
    yield takeEvery(SeaLogActionTypes.UPDATE_SEA_LOG,updateSeaLog)
}
export function* watchDeleteSeaLog():any{
    yield takeEvery(SeaLogActionTypes.DELETE_SEA_LOG,deleteSeaLog)
}


function* rutasSaga(): any {
    yield all([
        fork(watchGetSeaLog),
        fork(watchListSeaLogs),
        fork(watchAddSeaLog),
        fork(watchUpdateSeaLog),
        fork(watchDeleteSeaLog),
    ]);
}

export default rutasSaga;
